import React, { useState, useEffect } from 'react';
import { Table } from 'components';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { Card, Button, Input, Dropdown, DatePicker, Row, Checkbox } from 'components';
import { Modal, Form } from 'react-bootstrap';
import ButtonBTN from 'react-bootstrap/Button';
import { currencyFormatter } from 'services/helpers';
import * as FileServer from 'file-saver';
import * as XLSX from 'xlsx';
import SendEmailModal from './SendEmailModal';

const Body = ({ _this }) => {
  const exportReport = () => {
    const extractedDataArray = [];
    for (const dataObject of _this.tableData) {
      let extractedData;

      extractedData = {
        'Location Name': dataObject.location_name,
        'Location ID': dataObject.location_id,
        'Total Sales': dataObject.total_sales,
        'Unique Patients': dataObject.unique_patients,
        'Total Units': dataObject.total_units,
        'Active Hspp Patients': dataObject.active_hspp_patients,
        Zone: dataObject.zone
      };

      extractedDataArray.push(extractedData);
    }

    const fileType =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    const ws = XLSX.utils.json_to_sheet(extractedDataArray);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'data');

    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

    // Create a Blob and save the Excel file
    const data = new Blob([excelBuffer], { type: fileType });
    FileServer.saveAs(data, 'Red Zone Report' + fileExtension);
  };

  const columns = [
    {
      id: 'selection',
      sortable: false,
      maxWidth: 40,
      Header: () => (
        <Checkbox
          type="checkbox"
          checked={_this.isAllSelected}
          onChange={_this.toggleSelectAll}
          disabled={_this.selectedFranchise.value === 'All' ? true : false}
        />
      ),
      Cell: (row) => {
        const isChecked = _this.isRowSelected(row.original.location_id);
        return (
          <Checkbox
            type="checkbox"
            className="flex justify-center items-center"
            checked={isChecked}
            onChange={() =>
              _this.toggleRow(
                row.original.location_id,
                row.original.location_name,
                row.original.active_hspp_patients
              )
            }
          />
        );
      }
    },
    {
      accessor: 'location_name',
      Header: 'Location Name',
      Cell: (row) => <div>{row.original.location_name}</div>
    },
    {
      accessor: 'location_id',
      Header: 'Location ID',
      Cell: (row) => <div>{row.original.location_id}</div>
    },
    {
      accessor: 'unique_patients',
      Header: 'Unique Patients',
      Cell: (row) => <div>{row.original.unique_patients}</div>
    },
    {
      accessor: 'total_sales',
      Header: 'Total Sales',
      Cell: (row) => <div>{currencyFormatter.format(row.original.total_sales)}</div>
    },

    {
      accessor: 'total_units',
      Header: 'Total Units',
      Cell: (row) => <div>{row.original.total_units}</div>
    },

    {
      accessor: 'active_hspp_patients',
      Header: 'Active Hspp Patients',

      Cell: (row) => (
        <div className="flex justify-center">
          <div
            className={`${
              row.original.zone == 'green' ? 'bg-green-600' : 'bg-red-700'
            } w-8 rounded-full font-bold text-white`}
          >
            {row.original.active_hspp_patients}
          </div>
        </div>
      )
    }
  ];

  return (
    <div>
      <Card className="flex mr-2 mt-2" paddingClass="px-1">
        <div className="flex justify-between items-center p-2 gap-2 flex-wrap">
          <h3 className="text-body-color text-xl font-semibold">
            Red Zone Report({_this.tableData?.length})
          </h3>
          <Dropdown
            className="w-64 z-50 text-xs"
            label="Select Franchise"
            controlId="select-franchise"
            required
            options={_this.franchiseOptions}
            value={_this.selectedFranchise}
            onChange={_this.setSelectedFranchise}
            placeholder="Select franchise"
          />

          <Dropdown
            className="w-40 z-50"
            label="Select Month"
            controlId="month-select"
            required
            options={_this.getMonthOptions()}
            value={_this.selectedMonth}
            onChange={_this.setSelectedMonth}
            placeholder="Choose a month"
          />

          <div className="flex gap-2 flex-wrap">
            <ButtonBTN
              onClick={() => _this.setSendEmailModalVisibility(true)}
              className={`bg-button-primary mb-2 mt-4`}
              variant="primary"
              id="export"
              disabled={_this.selectedRows.length === 0 ? true : false}
            >
              Send Email
            </ButtonBTN>
          </div>
        </div>
      </Card>
      <Card className="flex mr-2 mt-2" paddingClass="px-1">
        <div>
          <div className="flex justify-between items-center p-2 gap-2 flex-wrap">
            <div className="flex gap-2 flex-wrap">
              <ButtonBTN
                onClick={() => exportReport()}
                className={`bg-button-primary mb-2`}
                variant="primary"
                id="export"
              >
                Export
              </ButtonBTN>
            </div>

            <input
              type="search"
              placeholder="Search.."
              value={_this.searchInput}
              onChange={(e) => _this.setSearchInput(e.target.value)}
            />
          </div>
        </div>
        <Table
          keyField="_id"
          columns={columns}
          data={_this.tableData}
          headerComponent={null}
          minRows={20}
        />

        <SendEmailModal _this={_this} />
      </Card>
    </div>
  );
};

export default Body;
